import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
//import 'semantic-ui-css/semantic.min.css';
import './polyfills';
import App from './App';
import config from './config';
import './styles/common/fonts/gtWalsheim/gt-walsheim-bold.ttf';
import './styles/common/fonts/gtWalsheim/gt-walsheim-medium.ttf';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import MsalConfig from "./components/utils/EntraUtils/AuthConfig";

const msalConfig = new MsalConfig();

ReactDOM.render(
  <MsalProvider instance={msalConfig.getMsalInstance()}>
    <Router basename={config.app.basename}>
      <App />
    </Router>
  </MsalProvider>,
  document.getElementById('root'),
);
